<div class="card">
  <div class="card__media"><ng-content select="[cardMedia]" /></div>
  <div class="card__body">
    <div class="card__title"><ng-content select="[cardTitle]" /></div>
    <div class="card__meta"><ng-content select="[cardMeta]" /></div>
    <div class="card__badges"><ng-content select="[cardBadges]" /></div>
    <ng-content />
  </div>
  <div class="card__actions"><ng-content select="[cardActions]" /></div>
  <div class="card__menu"><ng-content select="[cardMenu]" /></div>
</div>
